import { render, staticRenderFns } from "./CoursesApplicationSlidebar.vue?vue&type=template&id=50b4fb18"
import script from "./CoursesApplicationSlidebar.vue?vue&type=script&lang=js"
export * from "./CoursesApplicationSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports